import {
  NotebookNoteAnnotationCreation,
  NotebookAnnotation,
  NotebookPage,
  NotebookPageNote,
  NotebookPageNoteApiModel,
} from "@modules/notebook-editor/notebook-editor-types.ts";
import { ApiResponse } from "@apis/api.ts";
import httpClient from "@plugins/http";

const fetchNotebookPageNotes = async (
  pageUuid: string,
): Promise<ApiResponse<NotebookPageNote[]>> => {
  const data = new URLSearchParams();
  data.append("pageUuid", pageUuid);
  return await httpClient.get(`/apis/notebook-page-note/list?${data}`);
};

const createNotebookPageNote = async (
  notebookPageNote: NotebookPageNoteApiModel,
): Promise<ApiResponse<NotebookPageNote>> => {
  return await httpClient.post(`/apis/notebook-page-note/create`, notebookPageNote);
};

const updateNotebookPageNote = async (
  noteUuid: string,
  notebookPageNote: NotebookPageNoteApiModel,
): Promise<ApiResponse<NotebookPageNote>> => {
  return await httpClient.post(`/apis/notebook-page-note/update/${noteUuid}`, notebookPageNote);
};

const deleteNotebookPageNote = async (noteUuid: string): Promise<ApiResponse<void>> => {
  return await httpClient.post(`/apis/notebook-page-note/delete/${noteUuid}`);
};

const reorderNotebookPageNote = async (
  noteUuid: string,
  noteOrder: string,
): Promise<ApiResponse<void>> => {
  const data = new URLSearchParams();
  data.append("noteOrder", noteOrder);
  return await httpClient.post(`/apis/notebook-page-note/reorder/${noteUuid}?${data}`);
};

const moveNotebookPageNoteSpecificPage = async (
  targetPageId: number,
  noteUuid: string,
): Promise<ApiResponse<NotebookPage[]>> => {
  const data = new URLSearchParams();
  data.append("targetPageId", targetPageId.toString());
  return httpClient.post(`/apis/notebook-page-note/move/specific/${noteUuid}?${data}`);
};

const createNoteAnnotation = async (
  notebookNoteAnnotation: NotebookNoteAnnotationCreation,
): Promise<ApiResponse<void>> => {
  return await httpClient.post(
    `/apis/notebook-page-note/annotation/create`,
    notebookNoteAnnotation,
  );
};

const fetchNotebookPageNoteAnnotation = async (
  noteUuid: string,
): Promise<ApiResponse<NotebookAnnotation>> => {
  const data = new URLSearchParams();
  data.append("noteUuid", noteUuid);
  return await httpClient.get(`/apis/notebook-page-note/annotation?${data}`);
};

export default {
  fetchNotebookPageNotes,
  createNotebookPageNote,
  updateNotebookPageNote,
  deleteNotebookPageNote,
  reorderNotebookPageNote,
  moveNotebookPageNoteSpecificPage,
  createNoteAnnotation,
  fetchNotebookPageNoteAnnotation,
};
